import {SortableContainer} from 'react-sortable-hoc';

// react-sortable-hoc was written for React 16, where its setState({sorting: true}) applied straight away. Under React 18
// the update waits for the next render, so with `distance` set, every mousemove before that render starts the drag
// again. Each extra start clones the item into another floating helper and loses the previous one, which stays frozen
// on screen while the new helper (a clone of the now hidden item, so invisible) follows the pointer. Trackpads send
// mousemoves fast enough to hit this on most drags. Ignoring a press while a helper is on the page stops it.
export default function sortableContainer(Component, config) {
  const Container = SortableContainer(Component, config);

  return class extends Container {
    constructor(props) {
      super(props);
      const handlePress = this.handlePress;
      this.handlePress = event => (this.helper && this.helper.isConnected ? Promise.resolve() : handlePress(event));
    }
  };
}
